<template>
    <div>
        <div class="filters-wrapper d-flex justify-content-start flex-wrap mb-3 mt-5">
            <div class="d-flex align-items-end w-100 flex-wrap" style="gap: 15px;">
                <div class="single-filter mb-0">
                    <app-form-group
                        class="mb-0"
                        type="password"
                        :label="$t('passcode')"
                        :placeholder="$t('passcode')"
                        v-model="formData.passcode"
                        :show-password="true"
                    />
                </div>
                <div class="single-filter mb-0">
                    <label class="text-left d-block mb-2">{{ $t('date') }}</label>
                    <date-range-picker
                        class="mb-0"
                        :preset-ranges="['today', 'thisMonth', 'last7Days', 'thisYear']"
                        @changed="onDateRangeChange"
                    />
                </div>
                <div class="single-filter mb-0">
                    <app-default-button
                        type="button"
                        :title="$t('search')"
                        @click="submitClick()"
                    />
                </div>
            </div>
        </div>

        <h2 v-if="hotelName" class="text-center mb-3">{{ hotelName }}</h2>

        <div class="card border-0 bg-transparent">
            <div class="card-body p-0">
                <div class="datatable">
                    <app-overlay-loader v-if="floorAssignmentLoading"/>
                    <div v-if="floorAssignmentData && floorAssignmentData.length > 0"
                         class="table-responsive custom-scrollbar table-view-responsive pt-3 mt-3">
                        <table class="table mb-0">
                            <thead>
                            <tr>
                                <th class="datatable-th pt-2">
                                    <span class="font-size-default"><span>{{ $t('work_date') }}</span></span>
                                </th>
                                <th class="datatable-th pt-2">
                                    <span class="font-size-default"><span>{{ $t('floor') }}</span></span>
                                </th>
                                <th class="datatable-th pt-2">
                                    <span class="font-size-default"><span>{{ $t('employees') }}</span></span>
                                </th>
                                <th class="datatable-th pt-2">
                                    <span class="font-size-default"><span>{{ $t('remark') }}</span></span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row, index) in floorAssignmentData" :key="index">
                                <td class="datatable-td">{{ formatDateToLocal(row.work_date) }}</td>
                                <td class="datatable-td">{{ row.floor }}</td>
                                <td class="datatable-td">
                                    <app-avatars-group
                                        :avatars-group-class="'avatars-group-w-50'"
                                        :name="'hotelFloorShareAvatarsGroup' + index"
                                        :avatars="getAvatars(row.employees)"
                                        :border="true"
                                        :shadow="true"
                                    />
                                </td>
                                <td class="datatable-td">{{ row.remark }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else style="min-height: 400px;" class="position-relative"
                         :class="{'loading-opacity': floorAssignmentLoading}">
                        <app-empty-data-block :message="$t('empty_data_block_dummy_message')"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
/* Standard filter styling - matches other screens like HouseKeeping */
</style>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {
    formatDateForServer,
    formatDateToLocal,
} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import DateRangePicker from "../../../../../core/components/date-range-picker/DateRangePicker";

export default {
    name      : "AppHotelFloorShare",
    mixins    : [HelperMixin],
    components: {DateRangePicker},
    props : {
        hotel_id    : null,
        from_date   : null,
        to_date     : null,
        passcode    : null,
    },
    data() {
        return {
            TENANT_BASE_URL,
            floorAssignmentLoading: false,
            hotelName: null,
            floorAssignmentData: [],
            formData: {
                from_date: this.from_date,
                to_date  : this.to_date,
                passcode : this.passcode || '',
                hotel_id : this.hotel_id,
                maid_id  : 0,
            },
        }
    },
    mounted() {
        this.queryUrl()
    },
    methods: {
        formatDateToLocal,
        queryUrl() {
            if (!this.formData.hotel_id) {
                return
            }

            this.floorAssignmentLoading = true
            const date = []
            const Errors = (error) => {
                if (error.response && error.response.data) {
                    this.$toastr.e(error.response.data.message)
                } else {
                    this.$toastr.e(error.message)
                }
            }

            if (this.formData.from_date) {
                date.push(formatDateForServer(this.formData.from_date))
            }
            if (this.formData.to_date) {
                date.push(formatDateForServer(this.formData.to_date))
            }

            const query = `date=${date.join(',')}&passcode=${this.formData.passcode}&maid_id=${this.formData.maid_id}`
            const floorAssignmentUrl = `${TENANT_BASE_URL}api/hotel/floor-assignment/share?hotel_id=${this.formData.hotel_id}&${query}`
            const hotelUrl = `${TENANT_BASE_URL}api/hotel/${this.formData.hotel_id}/show?passcode=${this.formData.passcode}`

            axiosGet(floorAssignmentUrl).then((res) => {
                this.floorAssignmentData = res.data
            }).catch(Errors).finally(() => {
                this.floorAssignmentLoading = false
            })

            axiosGet(hotelUrl).then((res) => {
                this.hotelName = res.data.name || null
            }).catch(Errors)
        },
        getAvatars(employees) {
            if (!employees || !employees.length) {
                return [];
            }
            return employees.map(item => {
                let imgUrl = undefined;
                if (item.profile_picture) {
                    imgUrl = item.profile_picture.full_url || item.profile_picture.file_url;
                }
                return {
                    img: imgUrl,
                    alt: item.full_name || '',
                    title: item.full_name || '',
                    subTitle: item.email
                };
            });
        },
        submitClick() {
            this.queryUrl()
            this.$hub.$emit(`reload-hotel-share-table`)
        },
        onDateRangeChange(value) {
            if (value && value.start) {
                this.formData.from_date = value.start
                this.formData.to_date = value.end || value.start
            }
        }
    }
}
</script>
